import React from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import Form from "../Form";
import Title from "../Title";
import { IConfigsContainer } from "./interface";
import StyledFieldset, { DivWithMarginBottom, FilterButtons } from "./styles";

const ConfigsContainer: React.FC<IConfigsContainer> = ({
	onSubmitConfigs = () => {},
	resetConfigs,
	showConfigs = true,
	className = "",
	children,
	showClearConfigs = true,
	showSubmitConfigs = true
}) => {
	const { translate } = useTranslation();
    
	return(
		<RCCGrid
			container
			styleInline="z-index:201;"
			className={className}
		>
			<StyledFieldset showFilters={showConfigs}>
				<legend>
					<Title size="xs" color="purple">
						{translate("Configurações")}
					</Title>
				</legend>
				<Form onSubmit={onSubmitConfigs}>
					<DivWithMarginBottom>
						{children}
					</DivWithMarginBottom>
					<FilterButtons>
						{showSubmitConfigs && (
							<RCCTooltip
								text={translate("Aplicar configurações")}
								color="blue"
							>
								<RCCButton
									icon={{name: "check", color: "#FFF", size: 16}}
									color="blue"
									layout="isRounded"
									size="xs"
									type="submit" />
							</RCCTooltip>
						)}
						{showClearConfigs && (
							<RCCTooltip
								text={translate("Limpar configurações")}
								color="yellow"
							>
								<RCCButton
									icon={{name: "broom", color: "#FFF", size: 16}}
									color="yellow"
									layout="isRounded"
									size="xs"
									onClick={resetConfigs}
								/>
							</RCCTooltip>
						)}
					</FilterButtons>
				</Form>
			</StyledFieldset>
		</RCCGrid>
	);};

export default ConfigsContainer;
